import { render, staticRenderFns } from "./MyCourseDetail.vue?vue&type=template&id=0d3d3d84&"
import script from "./MyCourseDetail.vue?vue&type=script&lang=js&"
export * from "./MyCourseDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyCourseDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports